export const PAGINAS_ROUTES_ADMIN  = {
    dashboard : 'dashboard',
    tarifas : 'tarifas',
    menus : 'menus',
    paquetesExtras : 'paquetes-extras',
    extras: 'extras',
    calendarioTarifas : 'calendario-tarifas',
    reservas : 'reservas',
    calendarioReservas: 'calendario-reservas',
    checkin : 'checkin',
    cocina : 'cocina',
    invitadosReserva: 'mis-invitados',
    eventosPrivados: 'eventos-privados',
    encuestas: 'encuestas',
    banner: 'banner',
    codigosDescuento : 'codigos-descuento',
    diasPaquete: 'dias-paquete'
}
